import { t } from '@alluzo/shared';
import { createFileRoute, Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { Button } from '~/components/ui/button';

import { TemplatesTab } from '~/features/report-templates/templates-tab';
import { useDocRights } from '~/features/report-templates/use-doc-rights';

/** A record's Report templates tab (step 8.1 of docs/plans/report-templates.md; boards use-Tab, use-Tab-Empty). */
function ReportTemplatesRoute(): ReactElement {
  const { recordId } = Route.useParams();
  const navigate = Route.useNavigate();
  const rights = useDocRights(recordId);
  return (
    <TemplatesTab
      key={recordId}
      recordId={recordId}
      mayMake={rights.mayMake}
      onGenerate={(starter) => void navigate({ to: '/records/$recordId/report-templates/new', params: { recordId }, search: starter === null ? {} : { starter } })}
      rowActions={(templateId) => (
        <>
          <Button variant="outline" size="sm" asChild>
            <Link to="/records/$recordId/report-templates/$templateId" params={{ recordId, templateId }}>
              {t('report_templates.open')}
            </Link>
          </Button>
          {rights.mayMake ? (
            <Button variant="ghost" size="sm" asChild>
              <Link to="/records/$recordId/report-templates/$templateId/edit" params={{ recordId, templateId }}>
                {t('report_templates.edit_with_os')}
              </Link>
            </Button>
          ) : null}
        </>
      )}
    />
  );
}

export const Route = createFileRoute('/_app/records/$recordId/report-templates/')({ component: ReportTemplatesRoute });
